<template>
  <topHeader />
  <div class=" transport-page">
    <div class="container">
     
      
      <div class="transport-cards">
        <div class="transport-card" v-for="(company, index) in transportCompanies" :key="index">
          <div class="card-header">
            <h3 class="company-name">{{ company.name }}</h3>
          </div>
          <div class="card-body">
            <div class="info-item">
              <span class="info-label">联系电话：</span>
              <span class="info-value">{{ company.phone }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">公司地址：</span>
              <span class="info-value">{{ company.address }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">运输范围：</span>
              <span class="info-value">{{ company.scope }}</span>
            </div>
          </div>
     
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import topHeader from '@/components/top-Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'TransportComponent',
  components: {
    topHeader,
    Footer
  },
  data() {
    return {
      transportCompanies: [
        {
          name: '秦土运输有限公司',
          phone: '13800138001',
          address: '秦皇岛市xxxxxxx',
          scope: '渣土运输、土方工程、建筑垃圾清运'
        },
        {
          name: '绿源物流有限公司',
          phone: '13900139002',
          address: '秦皇岛市xxxxxxx',
          scope: '绿化土方、回填土、工程土方运输'
        },
        {
          name: '通达运输集团',
          phone: '13700137003',
          address: '秦皇岛市xxxxxxx',
          scope: '大型土方运输、矿山开采运输、道路工程运输'
        },
        {
          name: '诚信土方运输队',
          phone: '13600136004',
          address: '秦皇岛市xxxxxxx',
          scope: '普通土方、特殊土方、短途运输'
        },
        {
          name: '迅捷物流运输有限公司',
          phone: '13500135005',
          address: '秦皇岛市xxxxxxx',
          scope: '长途运输、仓储物流、工程物资配送'
        },
        {
          name: '恒通土石方工程有限公司',
          phone: '13400134006',
          address: '秦皇岛市xxxxxxx',
          scope: '土石方工程、地基回填、道路建设运输'
        }
      ]
    }
  },
  methods: {
    contactCompany(company) {
      // 这里可以实现联系商家的逻辑，比如跳转到联系页面或弹出联系信息
      alert(`联系 ${company.name}\n电话: ${company.phone}`);
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页面标题样式 */
.page-title {
 
  color: #422C27;
  margin: 30px 0;
  font-size: 28px;
  font-weight: bold;
}

/* 卡片容器样式 */
.transport-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin: 40px 0;
}

/* 单个卡片样式 */
.transport-card {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.transport-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* 卡片头部样式 */
.card-header {
    
  background: linear-gradient(135deg, #422C27 0%, #0d6b5f 100%);
  color: white;
  padding: 15px 20px;
}

.company-name {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

/* 卡片内容样式 */
.card-body {
    text-align: left;
  padding: 20px;
}

.info-item {
  display: flex;
  margin-bottom: 12px;
  line-height: 1.6;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  font-weight: bold;
  color: #333;
  min-width: 80px;
  flex-shrink: 0;
}

.info-value {
  color: #666;
  flex: 1;
}

/* 卡片底部样式 */
.card-footer {
  padding: 15px 20px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  text-align: right;
}

.contact-btn {
  background: #422C27;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.contact-btn:hover {
  background: #0d6b5f;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .transport-cards {
    grid-template-columns: 1fr;
  }
  
  .page-title {
    font-size: 24px;
    margin: 20px 0;
  }
  
  .info-item {
    flex-direction: column;
  }
  
  .info-label {
    min-width: auto;
    margin-bottom: 4px;
  }
}
</style>
